export type PusherErrorWithResponse = Error & {
  data: {
    body: {
      errors: Record<string, unknown>;
    }
  }
};

const isAnObject = (v: unknown): v is object =>
  typeof v === 'object'
  && v !== null
  && !Array.isArray(v);

// can be used to distinguish between 4xx responses and 5xx responses
export const isPusherErrorWithResponse = (error: unknown): error is PusherErrorWithResponse => {
  if (typeof error !== 'object' || error === null) return false;
  if (!('data' in error) || !isAnObject(error.data)) return false;
  if (!('body' in error.data) || !isAnObject(error.data.body)) return false;
  return ('errors' in error.data.body && isAnObject(error.data.body.errors));
};